import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import { useColorMode } from '../contexts/ColorModeContext';

export default function ColorModeToggle({ sx, size = 'small', placement = 'right' }) {
  const { mode, toggleColorMode } = useColorMode();
  const isDark = mode !== 'light';
  const label = isDark ? 'Switch to light mode' : 'Switch to dark mode';

  return (
    <Tooltip title={label} placement={placement}>
      <IconButton
        size={size}
        onClick={toggleColorMode}
        aria-label={label}
        sx={{ color: 'text.secondary', ...sx }}
      >
        {isDark ? <LightModeOutlinedIcon fontSize="small" /> : <DarkModeOutlinedIcon fontSize="small" />}
      </IconButton>
    </Tooltip>
  );
}
